import { Component, Input, ViewEncapsulation } from '@angular/core';
import { rolesRoute } from 'src/app/app-routing.module';
import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { RolePrivileges } from '../../models/role-privileges';
import { RoleOrderingOptions, RoleRegisterOptions } from '../../models/role-register-options';
import { RoleRegisterListItem } from '../../models/role-register-results.model';
import { selectQuickFilters } from '../../state/role-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-role-register-view',
    styleUrls: ['./account-role-register-view.component.scss'],
    templateUrl: './account-role-register-view.component.html',
    standalone: false
})
export class AccountRoleRegisterViewComponent extends EntityRegisterView<
   RoleRegisterListItem,
   RoleRegisterOptions,
   RoleOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() includeInactive: boolean;

   @Input() rolePrivileges: RolePrivileges;

   getRouterLink(id: number) {
      return `/${rolesRoute}/${id}`;
   }
}
